import React from "react";
import { Button, Container } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import moment from "moment";
import { createWorkingTimesBatch } from "actions/WorkingTime";
import HeaderMain from "components/HeaderMain/HeaderMain";
import NewInterval from "./components";
import { BULK_CREATE_INTERVALS_INITIAL_VALUES } from "constants/WorkingTime";
import styles from "./BulkCreateIntervals.module.css";

const BulkCreateIntervals = ({ route, navigate }) => {
  const dispatch = useDispatch();

  const validateValues = async values => {
    const errors = {};

    values.intervals.map(
      ({ areaData, generalTaskId, employee, startAt, endAt }) => {
        if (areaData.selectedAreas.length === 0) {
          errors["areaData"] = "Required field";
        }

        if (!generalTaskId) {
          errors["generalTaskId"] = "Required field";
        }

        if (employee.length === 0) {
          errors["employee"] = "Required field";
        }

        if (!startAt) {
          errors["startAt"] = "Required field";
        }

        if (!endAt) {
          errors["endAt"] = "Required field";
        }

        if (!!startAt && !!endAt) {
          const start = moment(startAt);
          let end = moment(endAt);

          if (end.isBefore(start)) {
            end.add(1, "day");
          }

          const diffHours = end.diff(start, "hours", true);

          if (diffHours > 12) {
            errors["diffHours"] =
              "Clock out time cannot be more than 12 hours after Clock in time.";
          }
        }
      }
    );

    return errors;
  };

  const onSubmit = values => {
    const dataToSend = [];

    values.intervals.forEach(({ areaData, employee, ...rest }) => {
      employee.forEach(employeeId => {
        dataToSend.push({
          ...rest,
          areas: areaData.selectedAreas
            .filter(
              item => item.type !== "farm" && !item.areaData.children?.length
            )
            .map(area => ({ areaId: area.id })),
          employeeId
        });
      });
    });

    dispatch(createWorkingTimesBatch(dataToSend))
      .then(() => navigate("/working_time"))
      .catch(e => console.error(e));
  };
  return (
    <Formik
      enableReinitialize
      validate={validateValues}
      validateOnMount
      validateOnChange
      onSubmit={onSubmit}
      initialValues={BULK_CREATE_INTERVALS_INITIAL_VALUES}
    >
      {({ errors, submitForm }) => (
        <Container id="el" fluid className={styles.root}>
          <HeaderMain route={route} online={true} />
          <div className={styles.contentWrapper}>
            <div className={styles.headerContainer}>
              <div className={styles.header}>Bulk create intervals</div>
            </div>
            <div className={styles.formContainer}>
              <NewInterval errors={errors} />
            </div>
            <div className={styles.buttonContainer}>
              <div className={styles.buttonWrapper}>
                <div className={styles.cancelButton}>
                  <Button
                    content="Cancel"
                    color="green"
                    basic
                    onClick={() => navigate("/working_time")}
                  />
                </div>
                <div className={styles.saveButton}>
                  <Button
                    content={"Save"}
                    color="green"
                    onClick={submitForm}
                    disabled={Object.keys(errors).length}
                  />
                </div>
              </div>
            </div>
          </div>
        </Container>
      )}
    </Formik>
  );
};

export default BulkCreateIntervals;
